import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import Toggle from 'components/toggle/toggle'
import styles from './SettingsToggle.scss'

const SettingsToggle = props => (
	<div styleName="SettingsToggle">
		<div styleName="SettingsToggle-left">
			<h4 styleName="SettingsToggle-left-title">{props.title}</h4>
			<p styleName="SettingsToggle-left-description">{props.description}</p>
		</div>
		<div styleName="SettingsToggle-right">
			<Toggle value={props.checked} onChange={props.onChange} />
		</div>
	</div>
)

SettingsToggle.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	checked: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
}

SettingsToggle.defaultProps = {
	title: '',
	description: '',
	checked: 0,
	onChange: () => { },
}

export default CSSModules(SettingsToggle, styles, { allowMultiple: true })
